import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'app/hooks';
import { selectCurrentStep, selectNumberOfSteps, setCurrentStep, setNumberOfSteps } from 'app/sharedSlice';
import Steps from 'components/Steps';
import type { IStep } from 'utils/types';

interface FlowViewProps {
  useSteps: () => IStep[];
  mainPanelComponent: React.ReactNode;
  completedComponent: React.ReactNode;
}

export default function FlowView(props: FlowViewProps): JSX.Element {
  const dispatch = useAppDispatch();
  const currentStep = useAppSelector(selectCurrentStep);
  const numberOfSteps = useAppSelector(selectNumberOfSteps);
  const steps = props.useSteps();

  useEffect(() => {
    dispatch(setNumberOfSteps(steps.length));
  }, [steps.length]);

  if (currentStep === numberOfSteps) {
    return <>{props.completedComponent}</>;
  }

  return (
    <div className="w-full h-full flex relative">
      <div className="w-1/3 wide:w-1/4 absolute left-0 bottom-0 top-[4rem] p-4 pr-2 overflow-y-auto">
        <div className="bg-white p-8">
          <Steps
            steps={steps}
            currentStep={currentStep}
            setCurrentStep={(step: number) => dispatch(setCurrentStep(step))}
          />
        </div>
      </div>
      <div className="w-2/3 wide:w-3/4 absolute right-0 bottom-0 top-[4rem] p-4 pl-2">
        <div className="h-full bg-white p-8 selection">{props.mainPanelComponent}</div>
      </div>
    </div>
  );
}
